import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { fetchLogout } from "../../pages/FetchAuth";
import { updateUserInfo } from "../../store/actions/userAction";
import { listNavMenu } from "../../utils/configData";
import { removeCryptoWalletAll } from "../../store/actions/cryptoWalletsAction";
import { removeBankWalletAll } from "../../store/actions/bankWalletsAction";

const UserMenu = () => {
  const { t } = useTranslation();
  const userInfo = useSelector((state) => state.user); // get user info from store
  const dispatch = useDispatch();
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [initials, setInitials] = useState(
    userInfo.fname[0] + userInfo.lname[0] // set initials
  );

  const userAvatar = userInfo.avatar ? ( // if avatar exists, display it, else display initials
    <img src={userInfo.avatar} alt="avatar" /> // (Workpiece for extension, currently there is no functionality for uploading a user photo)
  ) : (
    <p>{initials}</p>
  );

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };

  useEffect(() => {
    setInitials(userInfo.fname[0] + userInfo.lname[0]); // update initials when user info changes
  }, [userInfo.fname, userInfo.lname]);

  const logout = () => {
    fetchLogout().then((data) => {
      updateUserInfo(dispatch, data.userData);
      dispatch(removeBankWalletAll());
      dispatch(removeCryptoWalletAll());
    });
  };

  return (
    <div
      className="userMenu only-desktop"
      onMouseEnter={toggleDropdown}
      onMouseLeave={toggleDropdown}
    >
      <div className="userMenu__img">{userAvatar}</div>
      <p className="userMenu__user-name">
        
        {userInfo.fname}{userInfo.mname ? ` ${userInfo.mname} ` : " "}{userInfo.lname}
      </p>
      <i
        className={`ri-arrow-down-s-line ${isDropdownVisible ? "rotate" : ""}`}
      ></i>
      {isDropdownVisible && (
        <div className="dropdownMenu">
          {listNavMenu.map((item, index) => (
            !item.isExternal ? (
              <Link key={index} to={item.url}>
                <i className={item.icon}></i>
                {t(item.name)}
              </Link>
            ) : (<a key={index} href={item.url} rel="noreferrer" target="_blank"><i className={item.icon}></i>
              {t(item.name)}</a>)
          )
          )
          }

          <div></div>
          <Link to="/sign-in" onClick={logout}>
            <i className="ri-logout-box-line"></i>
            {t("Log out")}
          </Link>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
